var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotocykl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.56 114.74",
    width: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 8px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M59.85,97.51c-5.66,8.18-15.2,13.48-25.96,13.22-16.35-.39-29.64-13.8-29.89-30.15-.26-17.13,13.55-31.11,30.63-31.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M164.73,49.71c15.32,1.9,27.13,15.11,26.82,31.01-.32,16.4-13.76,29.77-30.16,30.01-17.13,.26-31.1-13.56-31.1-30.63,0-7.79,2.91-14.89,7.69-20.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "59.79 42.17 26.86 23.32 36.28 19.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M170.47,33.71c-3.27-.67-6.65-1-10.13-.96-25.73,.31-46.78,22.16-46.78,47.9v7.23h-40.06l-6.13-17.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "160.69 79.87 144.67 35.57 153.62 23.32 130.53 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M153.62,23.32c-19.79-4.24-54.19-2.83-71.16,18.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 67.38,
    y1: 70.45,
    x2: 34.4,
    y2: 79.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 59.84,
    y1: 42.17,
    x2: 82.46,
    y2: 42.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 115.4,
    y1: 67,
    x2: 92.83,
    y2: 67
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotocykl);
export default __webpack_public_path__ + "static/media/motocykl.a3a4dbca0cc7cdafdfb80e3eb8798f66.svg";
export { ForwardRef as ReactComponent };